import request from "@/utils/request";
// 获取接收人列表
export function getFilterMsg(params) {
  return request({
    url: "/h5/setting/getFilterMsg",
    method: "post",
    params,
  });
}
// 保存消息过滤设置
export function saveUnFilterMsg(params) {
  return request({
    url: "/h5/setting/saveUnFilterMsg",
    method: "post",
    params,
  });
}